import React, { Component } from 'react'
import Select from 'react-select'

import ButtonActualizar from './ButtonActualizar'

export default class AppAño extends Component {

  constructor(props){
    super(props)
    this.state = {
      selectOptions : [
          {value:'2019', label:'Año 2019'},
          {value:'2020', label:'Año 2020'},
          {value:'2021', label:'Año 2021'},
          {value:'2022', label:'Año 2022'},
          {value:'2023', label:'Año 2023'},
          {value:'2024', label:'Año 2024'},
          {value:'2025', label:'Año 2025'},
          {value:'2026', label:'Año 2026'},
          {value:'2027', label:'Año 2027'},
          {value:'2028', label:'Año 2028'},
          {value:'2029', label:'Año 2029'},
          {value:'2030', label:'Año 2030'},
          {value:'2031', label:'Año 2031'},
          {value:'2032', label:'Año 2032'},
          {value:'2033', label:'Año 2033'},
          {value:'2034', label:'Año 2034'},
          {value:'2035', label:'Año 2035'},

      ],
      id: "",
      name: ''
    }
  }

  handleChange(e){
   
   this.setState({id:e.value, name:e.label})
  } 

  render() {
    
    return (
      <div>
        <Select options={this.state.selectOptions} 
        onChange={this.handleChange.bind(this)}
      />
    <p>Usted Seleccionó <strong>{this.state.name}</strong> </p>
     <ButtonActualizar
    
     combo1={this.props.combo1}
     comboId1={this.props.comboId1}
     combo2={this.state.name}
     comboId2={this.state.id}
     />
     
      </div>
    )
  }
}